<script setup lang="ts">
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const playerFlagsStore = usePlayerFlagsStore()

async function completeTutorial() {
  // Mark the tutorial as complete and permanently hide it
  await playerFlagsStore.setFlag('tutorial_last_words', 'true')
  await playerFlagsStore.setFlag('tutorial_current_step', 'tutorial_last_words')
  await playerFlagsStore.setFlag('tutorial_complete', 'true')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/news.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.lastWords.thankYou') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.lastWords.checkIn') }}
      </p>
    </template>

    <template #alerts>
    </template>

    <template #buttons>
      <ActionButton @click="completeTutorial">
        {{ t('tutorial.lastWords.thankYouBtn') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">
</style>